/**
 * @generated SignedSource<<759ab4be1b51ef4e363a8c19a86b4fbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProducSkuImageDesktopProps_ProductSku$data = {
  readonly id: string;
  readonly name: string;
  readonly images: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly urlFullSize: string;
      };
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"ProductSkuImagesGallery_ProductSkuImageConnection" | "ProductSkuThumbnails_ProductSkuImageConnection">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuHighlightedPromotion_ProductSku">;
  readonly " $fragmentType": "ProducSkuImageDesktopProps_ProductSku";
};
export type ProducSkuImageDesktopProps_ProductSku$key = {
  readonly " $data"?: ProducSkuImageDesktopProps_ProductSku$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProducSkuImageDesktopProps_ProductSku">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProducSkuImageDesktopProps_ProductSku",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuImageConnection",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuImageEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSkuImage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": "urlFullSize",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "size",
                      "value": 2000
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": "url(size:2000)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductSkuImagesGallery_ProductSkuImageConnection"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductSkuThumbnails_ProductSkuImageConnection"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductSkuHighlightedPromotion_ProductSku"
    }
  ],
  "type": "ProductSku",
  "abstractKey": null
};
})();

(node as any).hash = "ed856c9bb2cadae3d147cbe75555739a";

export default node;
